import { render, staticRenderFns } from "./SpringManagement.vue?vue&type=template&id=7642da53&scoped=true"
import script from "./SpringManagement.vue?vue&type=script&lang=js"
export * from "./SpringManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/spa.css?vue&type=style&index=0&id=7642da53&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642da53",
  null
  
)

export default component.exports